import { render, staticRenderFns } from "./locationAddOrUpdate.vue?vue&type=template&id=61d8bf0e&"
import script from "./locationAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./locationAddOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./locationAddOrUpdate.vue?vue&type=style&index=0&id=61d8bf0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports